import './Loading.scss'
import React from 'react'

export default () => (
  <div></div>
)
